__turbopack_context__.v({
  "body": "fIGGMW_body",
  "icon": "fIGGMW_icon",
  "icons": "fIGGMW_icons",
  "indicator": "fIGGMW_indicator",
  "indicatorSlot": "fIGGMW_indicatorSlot",
  "item": "fIGGMW_item",
  "label": "fIGGMW_label",
  "labelRow": "fIGGMW_labelRow",
  "linkRow": "fIGGMW_linkRow",
  "panel": "fIGGMW_panel",
  "panelInner": "fIGGMW_panelInner",
  "trigger": "fIGGMW_trigger",
  "wrap": "fIGGMW_wrap",
});
